import { render, staticRenderFns } from "./customPcgDatatable.vue?vue&type=template&id=55c65b98&"
import script from "./customPcgDatatable.vue?vue&type=script&lang=js&"
export * from "./customPcgDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports